import cssVariables from 'tfs.css-variables'

export default {
  title: {
    color: cssVariables.colorGreen,
    marginTop: 0,
  },
  button: {
    marginTop: '1rem',
  },
}
